"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _LayoutPanelActions = _interopRequireDefault(require("./_LayoutPanelActions"));

var _LayoutPanelBody = _interopRequireDefault(require("./_LayoutPanelBody"));

var _LayoutPanelFilters = _interopRequireDefault(require("./_LayoutPanelFilters"));

var _LayoutPanelFooter = _interopRequireDefault(require("./_LayoutPanelFooter"));

var _LayoutPanelHead = _interopRequireDefault(require("./_LayoutPanelHead"));

var _LayoutPanelHeader = _interopRequireDefault(require("./_LayoutPanelHeader"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _layoutGrid = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/layout-grid.css") : void 0);

var _layoutPanel = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/layout-panel.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _layoutGrid.default), _layoutPanel.default));
/** A **LayoutPanel** is used to encapsulate part of the content, form elements, lists, collections, etc., on a page.
Place patterns and interactions within panels on your pages to achieve focus and separation for the tasks at-hand
with the information displayed inside the panel. */

var LayoutPanel = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "cssNamespace"]);
  var panelClasses = classnames("".concat(cssNamespace, "-layout-panel"), className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: panelClasses,
    ref: ref
  }), children);
});

LayoutPanel.displayName = 'LayoutPanel';
process.env.NODE_ENV !== "production" ? LayoutPanel.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string
} : void 0;
LayoutPanel.Actions = _LayoutPanelActions.default;
LayoutPanel.Body = _LayoutPanelBody.default;
LayoutPanel.Filters = _LayoutPanelFilters.default;
LayoutPanel.Footer = _LayoutPanelFooter.default;
LayoutPanel.Head = _LayoutPanelHead.default;
LayoutPanel.Header = _LayoutPanelHeader.default;

var _default = (0, _withStyles.default)(LayoutPanel);

exports.default = _default;